import qs from 'qs';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export function useParseQueryString<T>(): T {
  const { search } = useLocation();
  return useMemo(
    () => qs.parse(search, { ignoreQueryPrefix: true }) as T,
    [search],
  );
}
